import { c as _c } from "react/compiler-runtime";
import { IcoCloseSmall16 } from '@onefootprint/icons';
import type { FeaturePreview } from '@onefootprint/request-types/dashboard';
import { Button, IconButton, LinkButton } from '@onefootprint/ui';
import { Trans, useTranslation } from 'react-i18next';
import { useLocalStorage } from 'usehooks-ts';
import useFeaturePreview from '@/hooks/use-feature-preview';
import useSession from '@/hooks/use-session';
type FeaturePreviewAnnouncementProps = {
  preview: FeaturePreview;
};

/** Introduces the new experience in its section until the user dismisses it. */
const FeaturePreviewAnnouncement = t0 => {
  const $ = _c(49);
  const {
    preview
  } = t0;
  const {
    t
  } = useTranslation("common");
  const {
    data
  } = useSession();
  const {
    isEnabled,
    setEnabled
  } = useFeaturePreview(preview);
  const [isSeen, setIsSeen] = useLocalStorage(`featurePreviewSeen:${data.user?.id}:${preview}`, false);
  let t1;
  if ($[0] !== preview) {
    t1 = $_0 => $_0.featurePreviews[preview].name;
    $[0] = preview;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t || $[3] !== t1) {
    t2 = t(_temp, {
      name: t(t1)
    });
    $[2] = t;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const title = t2;
  if (isSeen || !isEnabled) {
    return null;
  }
  let t3;
  if ($[5] !== setEnabled) {
    t3 = () => {
      setEnabled(false);
    };
    $[5] = setEnabled;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleSwitchBack = t3;
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp2);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== setIsSeen) {
    t5 = () => setIsSeen(true);
    $[9] = setIsSeen;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <IconButton aria-label={t4} icon={IcoCloseSmall16} color="tertiary" size="tiny" variant="ghost" className="absolute top-3 right-3" onClick={t5} />;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== title) {
    t7 = <p className="text-label-2 text-primary">{title}</p>;
    $[14] = title;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== preview) {
    t8 = $_2 => $_2.featurePreviews[preview].announcement;
    $[16] = preview;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t || $[19] !== t8) {
    t9 = t(t8);
    $[18] = t;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t(_temp4);
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10) {
    t11 = <Trans ns="common" i18nKey={_temp3} components={{
      link: <LinkButton href="/settings/feature-previews" variant="label-2" className="align-baseline! underline! underline-offset-2">{t10}</LinkButton>
    }} />;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t9) {
    t12 = <p className="text-body-2 text-tertiary">{t9}{" "}{t11}</p>;
    $[25] = t11;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== setIsSeen) {
    t13 = () => setIsSeen(true);
    $[28] = setIsSeen;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t) {
    t14 = t(_temp5);
    $[30] = t;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = <Button size="compact" variant="primary" onClick={t13}>{t14}</Button>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t) {
    t16 = t(_temp6);
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== handleSwitchBack || $[38] !== t16) {
    t17 = <Button size="compact" variant="secondary" onClick={handleSwitchBack}>{t16}</Button>;
    $[37] = handleSwitchBack;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t15 || $[41] !== t17) {
    t18 = <div className="flex flex-wrap items-center gap-2 mt-3">{t15}{t17}</div>;
    $[40] = t15;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t12 || $[44] !== t18 || $[45] !== t6 || $[46] !== t7 || $[47] !== title) {
    t19 = <section aria-label={title} className="relative flex flex-col gap-1 p-4 pr-12 mb-4 border border-solid rounded-default border-tertiary bg-primary shadow-sm">{t6}{t7}{t12}{t18}</section>;
    $[43] = t12;
    $[44] = t18;
    $[45] = t6;
    $[46] = t7;
    $[47] = title;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  return t19;
};
export default FeaturePreviewAnnouncement;
function _temp($) {
  return $.components.featurePreviewAnnouncement.title;
}
function _temp2($_1) {
  return $_1.components.featurePreviewAnnouncement.dismiss;
}
function _temp3($_3) {
  return $_3.components.featurePreviewAnnouncement.settingsHint;
}
function _temp4($_4) {
  return $_4.components.featurePreviewAnnouncement.settingsLink;
}
function _temp5($_5) {
  return $_5.components.featurePreviewAnnouncement.gotIt;
}
function _temp6($_6) {
  return $_6.components.featurePreviewAnnouncement.switchBack;
}